import constants from '@/config/constants';
import { callApi } from '@/services/CallApi.service';

const changePassword = async (accessToken) => {

    const options = {
        url: `${constants.api.baseUrl}/account/change-password-link`,
        method: 'GET',
    };

    return await callApi(options, accessToken);
};
export default {
    changePassword,
};
